import { Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import PDFPage from './PDFDocument';

const styles = StyleSheet.create({
  coverPage: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '60%',
    marginBottom: 40,
  },
  logo: {
    // Native asset is 1800x1800 (1:1). Set both dimensions and prevent the
    // column flex layout from vertically shrinking (and thus stretching) it.
    width: 200,
    height: 200,
    flexShrink: 0,
    objectFit: 'contain',
    marginBottom: 20,
  },
  title: {
    fontSize: 28,
    fontWeight: 'bold',
    marginBottom: 15,
    color: '#4F5F4B',
    textAlign: 'center',
  },
  subtitle: {
    fontSize: 20,
    marginBottom: 10,
    textAlign: 'center',
    fontWeight: 'bold',
  },
  text: {
    fontSize: 14,
    marginBottom: 5,
    textAlign: 'center',
  },
  advisorSection: {
    marginTop: 20,
    alignItems: 'center',
  },
  advisorTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 5,
  },
  advisorName: {
    fontSize: 16,
  },
});

const CoverPagePDF = ({ clientData, date, pageNumber }) => {
  const agentName = `${clientData.agent_firstname} ${clientData.agent_lastname}`

  return (
    <PDFPage 
      pageNumber={pageNumber}
      showDisclaimer={true}
      showFooter={true}
    >
      <View style={styles.coverPage}>
        {/* Ashthorn rebrand logo. Keep it legible for PDF/print output
            (per Summit compliance, Change 6 — avoid low-contrast assets). */}
        <Image
          src="/images/ashthorn_logo.svg"
          style={styles.logo}
        />
        <Text style={styles.title}>Financial Plan Report</Text>
        <Text style={styles.subtitle}>{clientData.displayName}</Text>
        <Text style={styles.text}>Prepared on {date}</Text>
        
        <View style={styles.advisorSection}>
          <Text style={styles.advisorTitle}>Advisor</Text>
          <Text style={styles.advisorName}>{agentName}</Text>
        </View>
      </View>
    </PDFPage>
  );
};

export default CoverPagePDF;